import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2a0e284d&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=2a0e284d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e284d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0e284d')) {
      api.createRecord('2a0e284d', component.options)
    } else {
      api.reload('2a0e284d', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=2a0e284d&scoped=true&", function () {
      api.rerender('2a0e284d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Form.vue"
export default component.exports